import { IconAiStar } from 'gatorcomponents';
import { GradientButton } from '@/pages/Studio/components';
import { useResize } from '@/hooks/useResize';

import * as Styles from './HGBuilderHighlight.styles';

import React from 'react';
import {
  DivContents,
  DivImg,
  Title,
  DivText,
  Subtitle,
  ButtonWrapper,
  WrapperTitle,
} from '../HGStudioHighlight/HGStudioHighlight.styles';

const HGBuilderHighlight = ({
  element,
  buttonIsLoading = false,
}) => {
  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;

  return (
    <DivContents id={element.id} key={element.id} data-testid={`highlight-${element.id}`}>
      <DivImg>
        <img
          src={element.image}
          alt="produto em destaque"
        />
      </DivImg>

      <DivText>
        <WrapperTitle>
          <Title data-testid={`title-${element.id}`}>{element.title}</Title>
          <IconAiStar color="primaryBlue" />
        </WrapperTitle>

        <Subtitle data-testid={`subtitle-${element.id}`}>
          {element.subtitle}
        </Subtitle>

        <Styles.Description data-testid={`description-${element.id}`}>
          {element.description}
        </Styles.Description>

        <ButtonWrapper>
          <GradientButton
            testId="cta"
            label={element.cta.label}
            variant="quaternary"
            size="lg"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </ButtonWrapper>
      </DivText>
    </DivContents>
  );
};

export default HGBuilderHighlight;
